"use client";

import { EdgenModalCreateAble } from "@components/EdgenModal";
import {
  UpgradeConfirmModalContent,
  type UpgradeConfirmModalContentProps,
  type UpgradeConfirmResult,
} from "./UpgradeConfirmModalContent";

export type OpenUpgradeConfirmParams = Omit<
  UpgradeConfirmModalContentProps,
  "onDone"
>;

/**
 * 以 EdgenModalCreateAble 打开升级确认（居中 480px，H5 同为居中弹窗，fe-spec §4.4）。
 * 关闭入口由内容区自绘，提交中不可关闭；关闭时 resolve 结果给调用方处理后续（成功弹窗 / 换卡等）。
 */
export const openUpgradeConfirmModal = (
  params: OpenUpgradeConfirmParams,
): Promise<UpgradeConfirmResult> =>
  new Promise<UpgradeConfirmResult>((resolve) => {
    const modal = EdgenModalCreateAble.call({
      destroyOnClose: true,
      className: "text-content_primary md:w-[480px] max-w-full rounded-2xl",
      showClose: false,
      maskClosable: false,
      contentStyle: { padding: 0 },
      children: (
        <UpgradeConfirmModalContent
          {...params}
          onDone={(result) => {
            EdgenModalCreateAble.end(modal, false);
            resolve(result);
          }}
        />
      ),
    });
  });
